export default "__VITE_ASSET__CUh8_dts__"